import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import CallData from "../classes/CallData" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import PageNavigator from "../classes/PageNavigator" ;
import IconButton from "./IconButton" ;
import SortedHeader from "./SortedHeader" ;
import LeadUtils from "../classes/LeadUtils" ;
import PaginationView from "./PaginationView" ;
import Query from "../classes/Query" ;
import SearchComponent from "./SearchComponent" ;
import SalesLeadListRequest from "../models/SalesLeadListRequest" ;
import Button from "./Button" ;
import SalesLeadList from "../classes/SalesLeadList" ;
import SalesLeadCount from "../classes/SalesLeadCount" ;
import ListWrapper from "../utils/ListWrapper" ;
import TwilioClient from "../classes/TwilioClient" ;
import Lead from "../models/Lead" ;
import TextView from "./TextView" ;
import SalesLeadCountRequest from "../models/SalesLeadCountRequest" ;
import DFile from "../classes/DFile" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import LeadStatus from "../classes/LeadStatus" ;
import EventBus from "../utils/EventBus" ;
import DashboardCardWidget from "./DashboardCardWidget" ;
import Browser from "../classes/Browser" ;
import ScrollView2 from "./ScrollView2" ;
import LabelDropdown from "./LabelDropdown" ;
import RPCServices from "../rpc/RPCServices" ;
import IconView from "./IconView" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;

type _ExportButtonOnPressed = ( d3eState : SalesDashboardViewRefs ) => void ;

type _SearchComponentOnChanged = ( text : string,d3eState : SalesDashboardViewRefs ) => void ;


  export  interface  SalesDashboardViewProps extends  BaseUIProps {   key?: string ;
   client: TwilioClient ;
   data: CallData ;
   user: User ;
 }
/// To store state data for SalesDashboardView 
   class  SalesDashboardViewRefs {   column2ScrollController: ui.ScrollController = new ui.ScrollController() ;
  public exportButton: ExportButtonState = new ExportButtonState() ;
 }

   interface  ExportButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: SalesDashboardViewRefs ;
   _onExportButtonHandler?: _ExportButtonOnPressed ;
 }

   class  ExportButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _ExportButtonWithState extends  ObservableComponent<ExportButtonWithStateProps> {   exportButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : ExportButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get exportButton (  ) : ExportButtonState {
 return this.props.d3eState.exportButton ; 
 }
  public get d3eState (  ) : SalesDashboardViewRefs {
 return this.props.d3eState ; 
 }
  public get _onExportButtonHandler (  ) : _ExportButtonOnPressed {
 return this.props._onExportButtonHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('exportButton',null,this.exportButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'exportButton', 'exportButton.hover' ],this.rebuild);
 }
  public exportButtonOnEnter ( event ) : void {
 return this.exportButton.setHover(true) ; 
 }
  public exportButtonOnExit ( event ) : void {
 return this.exportButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.exportButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:Button({ padding:cStyle.tButtonLightPaddingOn, decoration:cStyle.tButtonLightDecorationOn, disable:this.exportButton.disable, onPressed:(  ) => {
 this._onExportButtonHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:ui.Row({ children:[ IconView({ size:18, icon:MaterialIcons.file_download, className:'xe15', key:'0' }), TextView({ data:'Export', className:'x0b3f', key:'1' }) ] }), onEnter:( event ) => {
 this.exportButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.exportButtonOnExit(event);
 }
 }), className:'Light xa3d' }) ; 
 }
 }
function ExportButtonWithState ( props : ExportButtonWithStateProps ) {
 return React.createElement(_ExportButtonWithState,props) ; 
 }


   class  _SalesDashboardViewState extends  ObservableComponent<SalesDashboardViewProps> {   static defaultProps = { client:null, data:null, user:null } ;
   d3eState: SalesDashboardViewRefs = new SalesDashboardViewRefs() ;
   request: SalesLeadListRequest = null ;
   leadsList: SalesLeadList = null ;
   leads: Array<Lead> = ListWrapper.widget(this,'leads') ;
   countRequest: SalesLeadCountRequest = null ;
   salesLeadCountQuery: SalesLeadCount = null ;
   salesLeads: Array<Lead> = ListWrapper.widget(this,'salesLeads') ;
   filterByStatus: string = 'All' ;
   filterByRange: string = 'Today' ;
   searchLead: string = '' ;
   filteredLeads: Array<Lead> = ListWrapper.widget(this,'filteredLeads') ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : SalesDashboardViewProps ) {
 super(props);

this.initState();
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.on([ 'request', 'request.applyStatus', 'request.ascending', 'request.fromDate', 'request.offset', 'request.orderBy', 'request.pageSize', 'request.status', 'request.toDate', 'request.user' ],this.computeLeadsList);

this.computeLeadsList();

this.on([ 'leadsList', 'leadsList.items' ],this.computeLeads);

this.computeLeads();

this.on([ 'countRequest', 'countRequest.fromDate', 'countRequest.pageSize', 'countRequest.toDate', 'countRequest.user' ],this.computeSalesLeadCountQuery);

this.computeSalesLeadCountQuery();

this.on([ 'salesLeadCountQuery', 'salesLeadCountQuery.items' ],this.computeSalesLeads);

this.computeSalesLeads();

this.updateSyncProperty('data',this.props.data);

this.updateSyncProperty('user',this.props.user);

this.on([ 'leads', 'leads.email', 'leads.name', 'leads.phone', 'searchLead' ],this.computeFilteredLeads);

this.computeFilteredLeads();

this.on([ 'filterByRange', 'filterByStatus', 'filteredLeads', 'filteredLeads.createdDate', 'filteredLeads.email', 'filteredLeads.name', 'filteredLeads.phone', 'filteredLeads.status', 'leadsList', 'leadsList.count', 'request', 'request.ascending', 'request.offset', 'request.orderBy', 'request.pageSize', 'salesLeads', 'salesLeads.status', 'searchLead' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : SalesDashboardViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }
 }
  public setRequest ( val : SalesLeadListRequest ) : void {
 let isValChanged :boolean=this.request !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('request',this.request,val);

this.request=val;

this.fire('request',this);
 }
  public setLeadsList ( val : SalesLeadList ) : void {
 let isValChanged :boolean=this.leadsList !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('leadsList',this.leadsList,val);

this.leadsList=val;

this.fire('leadsList',this);
 }
  public computeLeadsList  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setLeadsList(( await Query.get().getSalesLeadList(UsageConstants.QUERY_GETSALESLEADLIST_SALESDASHBOARDVIEW_PROPERTIES_LEADSLIST_COMPUTATION,this.request)));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadsList : ' + exception.toString());

this.setLeadsList(null);
 }
 }
  public setLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.leads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('leads',this.leads,val);

this.leads.clear();

this.leads.addAll(val);

this.fire('leads',this);
 }
  public addToLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.leads.contains(val) ) this.leads.add(val);
 }
 else {
 this.leads.remove(this.leads.elementAt(index));

this.leads.add(val);
 }

this.fire('leads',this,val,true);

this.updateObservable('leads',null,val);
 }
  public removeFromLeads ( val : Lead ) : void {
 this.leads.remove(val);

this.fire('leads',this,val,false);

this.removeObservable('leads',val);
 }
  public computeLeads  =  (  ) : void  =>  {
 try {
 this.setLeads(Array.from(this.leadsList.items.isNotEmpty ? this.leadsList.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeLeads : ' + exception.toString());

this.setLeads([  ]);
 }
 }
  public setCountRequest ( val : SalesLeadCountRequest ) : void {
 let isValChanged :boolean=this.countRequest !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('countRequest',this.countRequest,val);

this.countRequest=val;

this.fire('countRequest',this);
 }
  public setSalesLeadCountQuery ( val : SalesLeadCount ) : void {
 let isValChanged :boolean=this.salesLeadCountQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('salesLeadCountQuery',this.salesLeadCountQuery,val);

this.salesLeadCountQuery=val;

this.fire('salesLeadCountQuery',this);
 }
  public computeSalesLeadCountQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setSalesLeadCountQuery(( await Query.get().getSalesLeadCount(UsageConstants.QUERY_GETSALESLEADCOUNT_SALESDASHBOARDVIEW_PROPERTIES_SALESLEADCOUNTQUERY_COMPUTATION,this.countRequest)));
 }
 catch ( exception ) {
 console.log(' exception in computeSalesLeadCountQuery : ' + exception.toString());

this.setSalesLeadCountQuery(null);
 }
 }
  public setSalesLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.salesLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('salesLeads',this.salesLeads,val);

this.salesLeads.clear();

this.salesLeads.addAll(val);

this.fire('salesLeads',this);
 }
  public addToSalesLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.salesLeads.contains(val) ) this.salesLeads.add(val);
 }
 else {
 this.salesLeads.remove(this.salesLeads.elementAt(index));

this.salesLeads.add(val);
 }

this.fire('salesLeads',this,val,true);

this.updateObservable('salesLeads',null,val);
 }
  public removeFromSalesLeads ( val : Lead ) : void {
 this.salesLeads.remove(val);

this.fire('salesLeads',this,val,false);

this.removeObservable('salesLeads',val);
 }
  public computeSalesLeads  =  (  ) : void  =>  {
 try {
 this.setSalesLeads(Array.from(this.salesLeadCountQuery.items.isNotEmpty ? this.salesLeadCountQuery.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeSalesLeads : ' + exception.toString());

this.setSalesLeads([  ]);
 }
 }
  public setFilterByStatus ( val : string ) : void {
 let isValChanged :boolean=this.filterByStatus !== val;

if ( !isValChanged ) {
 return ; 
 }

this.filterByStatus=val;

this.fire('filterByStatus',this);
 }
  public setFilterByRange ( val : string ) : void {
 let isValChanged :boolean=this.filterByRange !== val;

if ( !isValChanged ) {
 return ; 
 }

this.filterByRange=val;

this.fire('filterByRange',this);
 }
  public setSearchLead ( val : string ) : void {
 let isValChanged :boolean=this.searchLead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchLead=val;

this.fire('searchLead',this);
 }
  public setFilteredLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.filteredLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('filteredLeads',this.filteredLeads,val);

this.filteredLeads.clear();

this.filteredLeads.addAll(val);

this.fire('filteredLeads',this);
 }
  public addToFilteredLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.filteredLeads.contains(val) ) this.filteredLeads.add(val);
 }
 else {
 this.filteredLeads.remove(this.filteredLeads.elementAt(index));

this.filteredLeads.add(val);
 }

this.fire('filteredLeads',this,val,true);

this.updateObservable('filteredLeads',null,val);
 }
  public removeFromFilteredLeads ( val : Lead ) : void {
 this.filteredLeads.remove(val);

this.fire('filteredLeads',this,val,false);

this.removeObservable('filteredLeads',val);
 }
  public computeFilteredLeads  =  (  ) : void  =>  {
 try {
 this.setFilteredLeads(Array.from(this.leads.where(( l ) => (l.name !== null && l.name.contains(this.searchLead)) || (l.email !== null && l.email.contains(this.searchLead)) || (l.phone !== null && l.phone.contains(this.searchLead))).toList()));
 }
 catch ( exception ) {
 console.log(' exception in computeFilteredLeads : ' + exception.toString());

this.setFilteredLeads([  ]);
 }
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ScrollView2({child:ui.Column({ children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Overview', softWrap:true, style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour xd55', key:'0' }), ui.Row({ children:[ ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:LabelDropdown<string>({ value:this.filterByStatus, items:LeadUtils.leadStatuses, onChanged:( value ) => {
 this.onStatusFilterDropdownOnChangedHandler(value,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
 }), key:'0', className:'xd2b4' }), LabelDropdown<string>({ value:this.filterByRange, items:LeadUtils.filterRanges, onChanged:( value ) => {
 this.onDateFilterDropdownOnChangedHandler(value,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
, key:'1' }) ], key:'1' }) ], className:'x7b4 hc h', key:'0' }), ui.Row({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ children:[ ([ LeadStatus.New, LeadStatus.AttemptedContact, LeadStatus.Contacted, LeadStatus.FollowUp, LeadStatus.DemoRequested ]).expand(( topStatus ) => [ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:DashboardCardWidget({ title:topStatus, bgcolor:topStatus === LeadStatus.New ? cStyle.c4 : topStatus === LeadStatus.AttemptedContact ? cStyle.c9 : topStatus === LeadStatus.Contacted ? cStyle.c6 : topStatus === LeadStatus.FollowUp ? cStyle.c5 : topStatus === LeadStatus.DemoRequested ? cStyle.c9 : cStyle.c4, statusCount:this.salesLeads.where(( c ) => c.status.name === topStatus.name).length, onClick:( leadStatus ) => {
 this.onTopCardClickHandler(leadStatus,topStatus,this.d3eState);
 }
 }), key:topStatus?.toString(), className:'xd72 hc h' }) ]) ], className:'xe85 hc h', key:'0' }), ui.Row({ children:[ ([ LeadStatus.Suspect, LeadStatus.Prospect, LeadStatus.ClosedWon, LeadStatus.Closed ]).expand(( bottomStatus ) => [ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:DashboardCardWidget({ title:bottomStatus, bgcolor:bottomStatus === LeadStatus.Suspect ? cStyle.c6 : bottomStatus === LeadStatus.Prospect ? cStyle.c5 : bottomStatus === LeadStatus.ClosedWon ? cStyle.c7 : bottomStatus === LeadStatus.Closed ? cStyle.c7 : cStyle.c5, statusCount:this.salesLeads.where(( c ) => c.status.name === bottomStatus.name).length, onClick:( leadStatus ) => {
 this.onBottomCardClickHandler(leadStatus,bottomStatus,this.d3eState);
 }
 }), key:bottomStatus?.toString(), className:'xc22 hc h' }) ]) ], className:'xce6 hc h', key:'1' }) ], className:'xd2e hc h', key:'0' }) ], className:'x450 hc h', key:'1' }), ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Recent Leads', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour x5ac3', key:'0' }), ui.Container({ className:'x39e hc h', key:'1' }), ExportButtonWithState({ d3eState:this.d3eState, _onExportButtonHandler:this.onExportButtonHandler, key:'2' }), ui.Container({ width:300, child:SearchComponent({ placeholder:'Search', value:this.searchLead, onChanged:( text ) => {
 this.searchComponentonChanged(text,this.d3eState);
 }
 }), key:'3', className:'xacd hc' }) ], className:'xd2c hc h', key:'0' }), ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), columnWidths:{0:new ui.FlexColumnWidth(1),1:new ui.FlexColumnWidth(1),2:new ui.FlexColumnWidth(1),3:new ui.FlexColumnWidth(1),4:new ui.FlexColumnWidth(1),5:new ui.FixedColumnWidth(70),}, children:[ ui.TableRow({ children:[ ui.TableCell({ child:SortedHeader({ name:'Name', assending:this.request.ascending, sorted:this.request.orderBy === 'name', onChanged:( value ) => {
 this.onNameSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'xbb7 hc h' }), className:'TableCellHeader table-column xa99 hc h', key:'0' }), ui.TableCell({ child:SortedHeader({ name:'Phone', assending:this.request.ascending, sorted:this.request.orderBy === 'phone', onChanged:( value ) => {
 this.onPhoneSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x090 hc h' }), className:'TableCellHeader table-column xa2b hc h', key:'1' }), ui.TableCell({ child:SortedHeader({ name:'Email', assending:this.request.ascending, sorted:this.request.orderBy === 'email', onChanged:( value ) => {
 this.onEmailSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x455 hc h' }), className:'TableCellHeader table-column x556 hc h', key:'2' }), ui.TableCell({ child:SortedHeader({ name:'Created Date', assending:this.request.ascending, sorted:this.request.orderBy === 'createdDate', onChanged:( value ) => {
 this.onCreatedDateSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'xddce hc h' }), className:'TableCellHeader table-column x1b4 hc h', key:'3' }), ui.TableCell({ child:SortedHeader({ name:'Status', assending:this.request.ascending, sorted:this.request.orderBy === 'status', onChanged:( value ) => {
 this.onStatusSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'xb39 hc h' }), className:'TableCellHeader table-column x06b hc h', key:'4' }), ui.TableCell({ child:TextView({ data:'', className:'hc' }), className:'TableCellHeader table-column x87ab hc', key:'5' }) ], className:'TableHeader table-row x727 hc h', key:'0' }), (this.filteredLeads).expand(( forItem ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.name, className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.phone, className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.email, className:'hc' }), className:'table-column hc', key:'2' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.createdDate !== null ? LeadUtils.toGMTFromDateTime(forItem.createdDate,{ format:'dd EEE, MMM y HH:mm' }) : '', className:'hc' }), className:'table-column hc', key:'3' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.start, children:[ ui.Container({ alignment:ui.Alignment.center, states:ui.joinStates({ 'data-c0':forItem.status.name === 'New', 'data-c1':forItem.status.name === 'Inprogress', 'data-c2':forItem.status.name === 'Closed', 'data-c3':forItem.status.name === 'Contacted', 'data-c4':forItem.status.name === 'Suspect', 'data-c5':forItem.status.name === 'Prospect', 'data-c6':forItem.status.name === 'Follow Up', 'data-c7':forItem.status.name === 'Closed Won', 'data-c8':forItem.status.name === 'Attempted Contact' },{}), padding:forItem.status.name === 'New' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Inprogress' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Closed' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Contacted' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Suspect' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Prospect' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Follow Up' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Closed Won' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Attempted Contact' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : null, decoration:forItem.status.name === 'New' ? new ui.BoxDecoration({color:cStyle.c4,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Inprogress' ? new ui.BoxDecoration({color:cStyle.c5,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Closed' ? new ui.BoxDecoration({color:cStyle.c7,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Contacted' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Suspect' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Prospect' ? new ui.BoxDecoration({color:cStyle.c5,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Follow Up' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Closed Won' ? new ui.BoxDecoration({color:new ui.Color(0xc7),borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Attempted Contact' ? new ui.BoxDecoration({color:cStyle.c9,borderRadius:ui.BorderRadius.circular(3.0)}) : new ui.BoxDecoration({  }), child:TextView({ data:forItem.status.name, style:new ui.TextStyle({color:cStyle.c14}), className:'x0eb hc' }), className:'x9fa hc', key:'0' }), ui.Container({ key:'1' }) ], className:'x567 hc h' }), className:'table-column x113 hc h', key:'4' }), ui.TableCell({ child:IconButton({ icon:MaterialIcons.edit, tooltip:'Edit', onPressed:(  ) => {
 this.onLeadEditHandler(forItem,this.d3eState);
 }
, className:'hc' }), className:'table-column hc', key:'5' }) ], onTap:( e ) => {
 e.stopPropagation();

this.onLeadSelectHandler(forItem,this.d3eState);
 }
, className:'TableRow1 table-row x247 hc h', key:forItem?.ident }) ]) ], className:'Table1 xaf70 hc h', key:'1' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.end, children:[ PaginationView({ pageSize:this.request.pageSize, total:this.leadsList?.count ?? 0, offset:this.request.offset, onChange:( pageSize,offset ) => {
 this.onChangePaginationViewHandler(pageSize,offset,this.d3eState);
 }
, key:'0' }) ], className:'x868 hc h', key:'2' }) ], className:'BaseViewStyle x3f9 hc h', key:'2' }) ], className:ui.join('SalesDashboardView xeba0 hc vc h v ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }),scrollDirection:ui.Axis.vertical,className:'SalesDashboardView xeba0 hc vc h v',controller:this.d3eState.column2ScrollController}) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setFilterByRange('Current Week');

this.setRequest(new SalesLeadListRequest({ user:this.user, pageSize:50, offset:0, orderBy:'', ascending:false, fromDate:LeadUtils.getFromDateFilter(this.filterByRange), toDate:LeadUtils.getToDateFilter(this.filterByRange), applyStatus:false }));

this.setCountRequest(new SalesLeadCountRequest({ user:this.user, pageSize:50, fromDate:LeadUtils.getFromDateFilter(this.filterByRange), toDate:LeadUtils.getToDateFilter(this.filterByRange) }));
 }
  public onExportButtonHandler  =  async  ( d3eState : SalesDashboardViewRefs ) : Promise<void>  =>  {
 let exportLeads :Array<Lead>=this.filteredLeads !== null ? this.filteredLeads : [  ];

let file :DFile=( await RPCServices.getExportFileUtils().createCSVForLeads(exportLeads));

if ( file !== null ) {
 Browser.download(file);

EventBus.get().fire(new SuccessMessage({ message:'Downloaded successfully.' }));
 }
 }
  public onChangePaginationViewHandler  =  ( pageSize : number,offset : number,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setPageSize(pageSize);

this.request.setOffset(offset);

this.setRequest(this.request.deepClone());
 }
  public onLeadSelectHandler  =  ( forItem : Lead,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.navigator.pushLeadOverviewPage({ lead:forItem, user:this.user, client:this.client, data:this.data, replace:false, target:'main' });
 }
  public onCreatedDateSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('createdDate');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onNameSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('name');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onPhoneSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('phone');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onEmailSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('email');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onStatusSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('status');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onStatusFilterDropdownOnChangedHandler  =  ( value : string,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.setFilterByStatus(value);

if ( value !== 'All' ) {
 this.request.setStatus(LeadStatus.values.firstWhere(( e ) => e.name === value,{ orElse:(  ) => null }));
 }

this.request.setApplyStatus(value === 'All' ? false : true);

this.setRequest(this.request.deepClone());
 }
  public onDateFilterDropdownOnChangedHandler  =  ( value : string,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.setFilterByRange(value);

this.request.setFromDate(LeadUtils.getFromDateFilter(this.filterByRange));

this.request.setToDate(LeadUtils.getToDateFilter(this.filterByRange));

this.setRequest(this.request.deepClone());

this.countRequest.setFromDate(LeadUtils.getFromDateFilter(this.filterByRange));

this.countRequest.setToDate(LeadUtils.getToDateFilter(this.filterByRange));

this.setCountRequest(this.countRequest.deepClone());
 }
  public onLeadEditHandler  =  ( forItem : Lead,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.navigator.pushLeadInformationPage({ user:this.user, lead:forItem, replace:false, client:this.client, target:'main', data:this.data, isNewObj:false });
 }
  public onTopCardClickHandler  =  ( leadStatus : LeadStatus,topStatus : LeadStatus,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setApplyStatus(true);

this.request.setStatus(leadStatus);

this.setRequest(this.request.deepClone());
 }
  public onBottomCardClickHandler  =  ( leadStatus : LeadStatus,bottomStatus : LeadStatus,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.request.setApplyStatus(true);

this.request.setStatus(leadStatus);

this.setRequest(this.request.deepClone());
 }
  public searchComponentonChanged  =  ( val : string,d3eState : SalesDashboardViewRefs ) : void  =>  {
 this.setSearchLead(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get exportButton (  ) {
 return this.d3eState.exportButton ; 
 }
 }
export default function SalesDashboardView ( props : SalesDashboardViewProps ) {
 return React.createElement(_SalesDashboardViewState,{ ..._SalesDashboardViewState.defaultProps, ...props }) ; 
 }
